<script>
export default {
  props: {
    activationTrigger: {
      type: String,
      default: 'hover',
    },
  },
  data() {
    return {
      isActivated: false,
    }
  },
  computed: {
    activationEvent() {
      // We may eventually support more types of activations
      return this.activationTrigger === 'hover' ? 'mouseover' : 'click'
    },
  },
  methods: {
    activate() {
      if (!this.isActivated) {
        this.isActivated = true
      }
    },
  },
  render() {
    return this.$slots.default({
      isActivated: this.isActivated,
      activationEvents: {
        [this.activationEvent]: () => {
          this.activate()
        },
      },
    })
  },
}
</script>
